module.exports = __webpack_public_path__ + "media/images/instagram-230d7165c85af373c5464c82fbaeb27a.svg";